<div class="maintain-container">
  <div class="maintain-content">
    <div class="maintenance-icon-wrapper">
      <div class="gear-container">
        <i class="bi bi-gear-fill gear-1"></i>
        <i class="bi bi-gear-fill gear-2"></i>
      </div>
      <i class="bi bi-tools maintenance-tools"></i>
    </div>

    <h1 class="maintain-title">
      <i class="bi bi-exclamation-triangle-fill"></i>
      ปิดปรับปรุงระบบชั่วคราว
    </h1>

    <div class="maintain-message">
      <p class="main-text">
        ขออภัยในความไม่สะดวก<br>
        ระบบกำลังอยู่ระหว่างการปรับปรุงและอัพเดทเวอร์ชั่น
      </p>
      
      <div class="schedule-card">
        <div class="schedule-header">
          <i class="bi bi-calendar-event"></i>
          <span>กำหนดการปรับปรุงจนถึงเวลา</span>
        </div>
        <div class="schedule-details">
          <div class="schedule-item">
            <i class="bi bi-calendar3"></i>
            <span class="label">วันที่:</span>
            <span class="value">{{ maintenanceDate }}</span>
          </div>
          <div class="schedule-item">
            <i class="bi bi-clock"></i>
            <span class="label">เวลา:</span>
            <span class="value">{{ maintenanceTime }}</span>
          </div>
        </div>
      </div>

      <div class="info-box">
        <i class="bi bi-info-circle-fill"></i>
        <div class="info-content">
          <p class="info-title">สิ่งที่คุณสามารถทำได้:</p>
          <ul class="info-list">
            <li>กรุณาลองเข้าใช้งานอีกครั้งหลังจากเวลาที่กำหนด</li>
            <li>บันทึกงานของคุณและปิดหน้าต่างนี้</li>
            <li>ติดต่อเราหากมีคำถามหรือข้อสงสัย</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="footer-text">
      <p>ขอบคุณสำหรับความเข้าใจและความอดทนของคุณ</p>
      <p class="brand">สมาคมผู้ประเมินค่าทรัพย์สินแห่งประเทศไทย (VAT)</p>
    </div>
  </div>

  <div class="background-decoration">
    <div class="circle circle-1"></div>
    <div class="circle circle-2"></div>
    <div class="circle circle-3"></div>
  </div>
</div>
